import React from 'react';
import { Button } from '@brighterion/br-ui';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { handleKeyEvent, handleOnClickEvent } from 'Utils';

import PageHeader from 'Components/PageHeader';
import { ROUTES } from 'Components/Breadcrumbs/routes';
import ButtonGroup from 'Components/ButtonGroup';

import { useFormikContext } from 'formik';
import styles from './Header.css';

const Header = () => {
    const { t } = useTranslation();
    const { initialValues } = useFormikContext<ParameterExpressionFormSchema>();
    const history = useHistory();

    return (
        <PageHeader className={styles.pageHeader}>
            <PageHeader.Left className={styles.pageHeaderLeft}>
                {t('ViewExpressionHeader', { parameterName: initialValues.displayName })}
                <span className={styles.pagesubHeaderLeft}>
                    {t(`ParameterPageHeaderStatus.${initialValues.status}`)}
                </span>
            </PageHeader.Left>
            <PageHeader.Right>
                <ButtonGroup direction='row'>
                    <Button
                        className={styles.backBtn}
                        onKeyDown={handleKeyEvent(() => history.push(ROUTES.PARAMETERS.INDEX))}
                        onClick={handleOnClickEvent(() => history.push(ROUTES.PARAMETERS.INDEX))}
                        variant='tertiary'
                        size='medium'
                        iconName='left-arrow-with-tail'
                    >
                        {t('Back To Manage Parameters')}
                    </Button>
                </ButtonGroup>
            </PageHeader.Right>
        </PageHeader>
    );
};

export default React.memo(Header);
